import { motion as Motion } from "framer-motion";
import styles from "./FooterMobile.module.scss";

export default function FooterMobile() {
  return (
    <Motion.div
      className={styles.footerWrap}
      initial={{ y: 42, opacity: 0, scale: 0.96 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 130, damping: 15, delay: 0.1 }}
    >
      <footer className={styles.footer}>
        <span className={styles.orbit} aria-hidden="true" />
        <span className={styles.glow} aria-hidden="true" />
        <span className={styles.scan} aria-hidden="true" />

        <span className={styles.mainLine}>
          <span className={styles.dot} aria-hidden="true" />
          Powered by Free Thinkers
        </span>

        <span className={styles.site}>notyu.com</span>
      </footer>
    </Motion.div>
  );
}
